import { render, staticRenderFns } from "./Entregas.vue?vue&type=template&id=54bc424e&scoped=true"
import script from "./Entregas.vue?vue&type=script&lang=js"
export * from "./Entregas.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Entregas.vue?vue&type=style&index=1&id=54bc424e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc424e",
  null
  
)

export default component.exports